import React from 'react';

export default function PrivacyPolicy() {
    return (
        <div className="min-h-screen bg-gray-50 flex justify-center p-4">
            <div className="max-w-3xl w-full bg-white rounded-2xl shadow-lg overflow-hidden">
                <div className="bg-primary-400 px-6 py-4">
                    <h1 className="text-2xl font-bold text-white">Privacy Policy</h1>
                </div>
                <div className="p-6 space-y-6 text-gray-700 font-medium leading-relaxed">
                    <section className="my-4">
                        <h2 className="text-xl font-bold text-slate-800 mb-2">1. Information We Collect</h2>
                        <p>
                            We collect personal information when you register: name, email,
                            phone number, and resume data. We also collect usage data.
                        </p>
                    </section>

                    <section className="my-4">
                        <h2 className="text-xl font-bold text-slate-800 mb-2">2. How We Use Data</h2>
                        <ul className="list-disc list-inside">
                            <li>To provide and improve our services.</li>
                            <li>To communicate updates and job alerts.</li>
                            <li>To comply with legal obligations.</li>
                        </ul>
                    </section>

                    <section className="my-4">
                        <h2 className="text-xl font-bold text-slate-800 mb-2">3. Cookies & Tracking</h2>
                        <p>
                            We use cookies and similar technologies to enhance your
                            experience. You can disable cookies in your browser settings.
                        </p>
                    </section>

                    <section className="my-4">
                        <h2 className="text-xl font-bold text-slate-800 mb-2">4. Data Sharing</h2>
                        <p>
                            We do not sell your personal data. We may share information
                            with trusted partners under confidentiality agreements.
                        </p>
                    </section>

                    <section className="my-4">
                        <h2 className="text-xl font-bold text-slate-800 mb-2">5. Data Security</h2>
                        <p>
                            We implement encryption and access controls to protect your
                            data. However, no system is completely secure.
                        </p>
                    </section>

                    <section className="my-4">
                        <h2 className="text-xl font-bold text-slate-800 mb-2">6. Your Choices</h2>
                        <p>
                            You can access, update, or delete your personal data by
                            contacting us at{' '}
                            <a href="mailto:info@santechnovation.com" className="text-secondary-500 underline">
                                info@santechnovation.com
                            </a>.
                        </p>
                    </section>

                    <section className="my-4">
                        <h2 className="text-xl font-bold text-slate-800 mb-2">7. Changes to Policy</h2>
                        <p>
                            We may revise this policy. The “Effective Date” at top reflects
                            the last update.
                        </p>
                    </section>
                </div>
            </div>
        </div>
    );
}
